import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { disableKosten } from '../../helpers/showKosten';
import { fn2nZ } from '../../core/formatter/formatNumber';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';


interface DatenauswertungWasserProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungWasserState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
}

export class DatenauswertungWasser extends React.Component<DatenauswertungWasserProps, DatenauswertungWasserState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {}
        };
    }

    private disableKosten: boolean;
    private entities: any[] = [
        { titel: i18n('Wasser', 'sys'), entity: IDs.ENT_ENERGIEDATEN_WASSER }
    ];
    private hasData: any = { regen_brunnennutzung: false, rueckerstattung: false };

    componentDidMount(): void {
        this.disableKosten = disableKosten(this.props.data);
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'jahr'
            ).getData()
        });
    }

    delColumns(rows: any[]): any[] {
        (rows || []).forEach((row: any[], index: number) => {
            if (!this.hasData.regen_brunnennutzung) {
                delete row[2];
            }

            if (this.disableKosten) {
                delete row[4]; // Kosten [€ (netto)]
                delete row[5]; // Kosten [€/m³]
                delete row[6]; // Abwasser (Kosten) [€ (netto)]
                delete row[7]; // Gesamtkosten Wasser & Abwasser [€ (netto)]
            }

            if (!this.hasData.rueckerstattung) {
                delete row[8];
            }
            // rows[index] = row.filter((item: any[]) => typeof item !== 'undefined');
        });

        return rows;
    }

    getValues(): any {
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];
        this.hasData.regen_brunnennutzung = false;
        this.hasData.rueckerstattung = false;

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            const wasser_verbrauch = kennzahlen[jahr] && kennzahlen[jahr].wasser_verbrauch_jahr
                ? kennzahlen[jahr].wasser_verbrauch_jahr
                : null;
            const regen = kennzahlen[jahr] && kennzahlen[jahr].regen_brunnennutzung
                ? kennzahlen[jahr].regen_brunnennutzung
                : 0;
            const wassergesamt_kosten = kennzahlen[jahr] && kennzahlen[jahr].wassergesamt_kosten
                ? kennzahlen[jahr].wassergesamt_kosten
                : null;
            const wasserbezug_kosten = kennzahlen[jahr] && kennzahlen[jahr].wasserbezug_kosten
                ? kennzahlen[jahr].wasserbezug_kosten
                : 0;
            const rueckerstattung = kennzahlen[jahr] && kennzahlen[jahr].rueckerstattung
                ? kennzahlen[jahr].rueckerstattung
                : 0;
            const abwasser_kosten = kennzahlen[jahr] && kennzahlen[jahr].abwasser_kosten
                ? kennzahlen[jahr].abwasser_kosten
                : 0;
            const wasser_preis = wasserbezug_kosten / wasser_verbrauch;
            const gesamt_wasser = wasser_verbrauch + regen;
            this.hasData.regen_brunnennutzung = !!(this.hasData.regen_brunnennutzung || regen);
            this.hasData.rueckerstattung = !!(this.hasData.rueckerstattung || rueckerstattung);
            const row = [
                jahr,
                fn2nZ(wasser_verbrauch), fn2nZ(regen), fn2nZ(gesamt_wasser), fn2nZ(wasserbezug_kosten),
                fn2nZ(wasser_preis), fn2nZ(abwasser_kosten), fn2nZ(wassergesamt_kosten), fn2nZ(rueckerstattung)
            ];
            const row_length: number = row.length;
            const hasValues: boolean = rowHasValues(row);
            const isWebForced: boolean = !!(!hasValues && this.state.validation[jahr]);
            const d1 = {
                jahr, verbrauch: wasser_verbrauch,
                ...(!this.disableKosten && { kosten: wassergesamt_kosten })
            };
            rows.push([
                <div data-text={row[0]}>
                    <div>{row[0]}</div>
                    {this.state.validation[jahr] &&
                        <ValidierungHinweise
                            data={this.props.data}
                            entities={this.entities}
                            id={jahr}
                            showPriorityColors
                            validation={this.state.validation}
                        />
                    }
                </div>,
                ...(!hasValues && this.state.validation[jahr]
                    ? Array.from(Array(row_length - 1), (): void => null)
                    : [...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                )
            ]);
            if (hasValues) {
                if (wasser_verbrauch !== null || (!this.disableKosten && wassergesamt_kosten !== null)) {
                    diag1.push(d1);
                }
            }
            custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
            row_web_forced.push(isWebForced);
        }
        return { rows: this.delColumns(rows), diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#4f81bd', color.zusatztools || '#f79646', color.dateneingabe || '#87bd51', '#51bd75', '#5163bd',
            '#9951bd', '#bd5175', '#bd5151'
        ];
        // const style: any = { sub: getStyle('sub') };
        // const totalWidth = 13 * 60; // Das war die Ausgangsbasis
        let numCols = 5 + (!this.disableKosten ? 4 : 0);
        numCols -= this.hasData.regen_brunnennutzung ? 0 : 1;
        numCols -= this.hasData.rueckerstattung ? 0 : 1;
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Auswertung Wasser', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_${i18n('Wasser', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'wasser' },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: i18n('Wasserverbrauch', 'sys'),
                        width: `${baseWidth * (3 - (this.hasData.regen_brunnennutzung ? 0 : 1))}%`,
                        columns: [
                            { label: i18n('Bezugsmenge Versorger', 'sys'), label2: 'm³', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Regen-/Brunnennutzung', 'sys'), label2: 'm³', customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Gesamtverbrauch', 'sys'), label2: 'm³', customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    {
                        label: i18n('Kosten', 'sys'),
                        width: `${baseWidth * 2}%`,
                        columns: [
                            { label2: `€ (${i18n('netto', 'sys')})`, customStyleLabel2: { borderTop: '0pt solid #fff' } },
                            { label2: '€/m³', customStyleLabel2: { borderTop: '0pt solid #fff' } }
                        ]
                    },
                    {
                        label: `${i18n('Abwasser', 'sys')} (${i18n('Kosten', 'sys')})`,
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: `€ (${i18n('netto', 'sys')})` }
                        ]
                    },
                    {
                        label: i18n('Gesamtkosten Wasser & Abwasser', 'sys'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: `€ (${i18n('netto', 'sys')})` }
                        ]
                    },
                    {
                        label: i18n('Abwasser Rückerstattung', 'sys'),
                        width: `${baseWidth}%`,
                        columns: [
                            { label2: `€ (${i18n('netto', 'sys')})` }
                        ]
                    }
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header', , , 'row_field_dark', , 'row_field_dark', , 'row_field_dark'],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            diagrams: [
                {
                    title: `${i18n('Wasserverbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n('Entwicklung der Kosten', 'sys')}` : ''}`,
                    titlePdf: `${i18n('Wasserverbrauch', 'sys')}${!this.disableKosten ? ` & ${i18n('Entwicklung der Kosten', 'sys')}` : ''}`,
                    legend: [`${i18n('Wasserverbrauch', 'sys')} [m³]`, ...(!this.disableKosten ? [`${i18n('Wasserkosten', 'sys')} [€]`] : [])],
                    unit: ['l', ...(!this.disableKosten ? ['€'] : [])],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['verbrauch', ...(!this.disableKosten ? ['kosten'] : [])],
                    data: values.diag1,
                    tickPeriod: [50, ...(!this.disableKosten ? [50] : [])],
                    singleYAxis: false,
                    lineColor,
                    containerSize: { width: '90%' }
                }
            ]
        };
        if (!this.hasData.rueckerstattung) {
            config.header.blocks.splice(5, 1); // Abwasser Rückerstattung
            config.row_classes.splice(9, 1);
        }
        if (this.disableKosten) {
            config.header.blocks.splice(4, 1); // Gesamtkosten Wasser & Abwasser
            config.row_classes.splice(8, 1);
            config.header.blocks.splice(3, 1); // Abwasser (Kosten)
            config.row_classes.splice(7, 1);
            config.header.blocks.splice(2, 1); // Kosten
            config.row_classes.splice(5, 2);
        }
        if (!this.hasData.regen_brunnennutzung) {
            config.header.blocks[1].columns.splice(1, 1);
            config.row_classes.splice(2, 1);
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label='Datenauswertung - Hinweise'
                helpKey='datenauswertung_wasser'
                type='info'
                editBar
            />
        );

        const jahresauswahl: any = <DatenauswertungJahrauswahl
                    jahrMin={this.state.jahrMin}
                    jahrMax={this.state.jahrMax}
                    jahrFirst={this.state.firstJahr}
                    jahrLast={this.state.lastJahr}
                    contextKey='datenauswertung'
                    onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                    onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                    renderClean={true}
                    wrapClass={datenauswertungStyle.datenauswertungFormField}
        
                />;
                const arr_header_form_elements: any[] = [
                    {
                        elem: jahresauswahl,
                        wrapClass: 'datenauswertungContentLeft',
                        skipFormFieldWrapper: true
                    },
                    {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                        wrapClass: 'datenauswertungContentGrow'
                    },
                    { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
                    { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
                    { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
                    { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
                ];
        

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='wasser'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = this.entities.map((item: any) => item.entity);
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasWasser);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WASSER, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
